import * as React from 'react';
import './Page.css';

import { ClassNames } from '../../_helpers/ClassNames';
import DocumentMeta from 'react-document-meta';
import AppProvider, { AppContextProps } from '../../_context/App';
import { RouteComponentProps, withRouter } from 'react-router';

import { Spinner } from '../Spinner/Spinner';
import objectFitImages from 'object-fit-images';
import Home from '../Home/Home';
import Overview from '../Overview/Overview';
import Project from '../Project/Project';
import PanelPage from '../PanelPage/PanelPage';
import Menu from '../Menu/Menu';
import Cookies from '../Cookies/Cookies';
import * as ReactGA from 'react-ga';

export type PageProps = {};

type State = {
	page?: IPageDto;
};
type Props = PageProps & {
	appContext: AppContextProps;
} & RouteComponentProps<any>;
class PageUnwrapped extends React.Component<Props, State> {
	private scrollContainer = document.scrollingElement
		? document.scrollingElement
		: document.documentElement;

	constructor(props: Props) {
		super(props);

		this.state = {
			page: props.appContext.app && props.appContext.app.Page,
		};
	}

	componentDidMount() {
		if (!this.state.page) {
			this._fetch();

			const { app } = this.props.appContext;

			if (app && app.Config) {
				ReactGA.initialize(`${app.Config.AnalyticsCode}`);
				ReactGA.pageview(window.location.pathname);
			}
		}

		objectFitImages();

		if (this.scrollContainer && this.scrollContainer.scrollTop > 0) {
			this.scrollContainer.scrollTop = 0;
		}
	}

	componentDidUpdate(prevProps: Props) {
		if (prevProps.location.pathname !== this.props.location.pathname) {
			this._fetch();

			const { app } = this.props.appContext;

			if (app && app.Config) {
				ReactGA.initialize(`${app.Config.AnalyticsCode}`);
				ReactGA.pageview(window.location.pathname);
			}
		}

		if (this.scrollContainer && this.scrollContainer.scrollTop > 0) {
			this.scrollContainer.scrollTop = 0;
		}
	}

	public render() {
		const { page } = this.state;
		const { app } = this.props.appContext;

		return (
			<div className={ClassNames('page', '')}>
				<Cookies appContext={this.props.appContext} />
				<div className={ClassNames('page', 'content')}>
					{page ? (
						<React.Fragment>
							<DocumentMeta
								title={page.PageTitle || ''}
								description={page.Description || ''}
							/>
							{app && <Menu menu={app.Menu} page={page} />}
							{page.type === 'Home' && <Home {...(page as HomeDto)} />}
							{page.type === 'Overview' && (
								<Overview {...(page as OverviewDto)} />
							)}
							{page.type === 'Project' && <Project {...(page as ProjectDto)} />}
							{page.type === 'PanelPage' && (
								<PanelPage {...(page as PanelPageDto)} />
							)}
						</React.Fragment>
					) : (
						<Spinner />
					)}
				</div>
			</div>
		);
	}

	private _fetch() {
		this.setState(() => {
			this.props.appContext.get(this.props.location.pathname).then((result) => {
				this.setState(() => ({ page: result }));
			});
			return { page: undefined };
		});
	}
}

export const Page = withRouter(AppProvider.Inject(PageUnwrapped));

export default Page;



// WEBPACK FOOTER //
// ./src/Components/Page/Page.tsx